import { axios } from '@/services/axios';

/**
 * Creates a service category. The API accepts id, name, description, image,
 * and type as a single multipart/form-data payload (unlike Templates, which
 * splits image upload into a separate call).
 *
 * @param {object} serviceCategoryData
 * @param {string} serviceCategoryData.id
 * @param {string} serviceCategoryData.name
 * @param {string} [serviceCategoryData.description]
 * @param {File}   [serviceCategoryData.image]
 * @param {string} serviceCategoryData.type
 */
export const createServiceCategory = ({
    id,
    name,
    description,
    image,
    type,
}) => {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('name', name);
    formData.append('description', description || '');
    formData.append('image', image);
    formData.append('type', type);

    return axios.post('/servicecategory', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
